/**
 * Backend contract when VITE_WORKSPACES_MODE=api:
 * - GET /v1/workspaces -> { workspaces: [{ id, name, icon, accent, description }] }
 * - POST /v1/workspaces -> { workspace } (workspace object also accepted)
 * - Scoped routes must honour X-Workspace-Id instead of ensure_default_workspace(user_id)
 */
import { fetchWorkspaces, createWorkspace as apiCreateWorkspace } from './workspacesApi'
import { createLocalWorkspace, listLocalWorkspaces } from './workspaceLocalRepository'
import { getCurrentUserId } from './getCurrentUserId'
import { workspaceRepositoryUsesLocal } from './workspaceRepositoryMode'

function localList() {
  return { workspaces: listLocalWorkspaces(getCurrentUserId()) }
}

export async function listWorkspaces(options = {}) {
  if (workspaceRepositoryUsesLocal()) return localList()
  const data = await fetchWorkspaces(options)
  return { workspaces: Array.isArray(data?.workspaces) ? data.workspaces : [] }
}

export async function createWorkspace(payload) {
  if (workspaceRepositoryUsesLocal()) return createLocalWorkspace(getCurrentUserId(), payload)
  const data = await apiCreateWorkspace(payload)
  return data?.workspace ?? data
}
